import React, { FC } from 'react';
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Grid from '@mui/material/Grid';

export enum DistributionBarVariant {
  Variant1,
  Variant2,
}

type EmptyDistributionBarProps = {
  label: string;
};

const useStyles = makeStyles(() => ({
  roundedBox: {
    borderRadius: '6px',
    backgroundColor: '#e4e4e4',
    textAlign: 'center',
    fontSize: 8,
    color: '#868686',
    padding: '4px',
  },
  barWrapper: {
    position: 'relative',
  },
}));

const EmptyDistributionBar: FC<EmptyDistributionBarProps> = ({ label = 'No data' }) => {
  const classes = useStyles();

  return (
    <Box position="relative">
      <Grid container>
        <Grid item xs={12} className={classes.barWrapper}>
          <Box className={classes.roundedBox}>
            <Typography>{label}</Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EmptyDistributionBar;
